import { Rest as ParentRest, RequestError } from '@libs/ts-fetch-rest';
import { nextRestMixin } from '@libs/next-fetch-rest-mixin';

// Re export types
export { RequestError };

export const Rest = nextRestMixin(ParentRest);
